import React, { useState } from "react";
import KickoutMemberModal from "./KickoutMemberModal";

function KickoutMemberButton({
  user_name: userName,
  kickout_member_path: kickoutMemberPath,
  trash_icon: trashIcon,
}) {
  const [isOpen, setModalOpen] = useState(false);

  return (
    <>
      <div
        role="button"
        onClick={() => setModalOpen(true)}
        className="pillRankingList__item__actionButton"
      >
        <img src={trashIcon} alt="Remove Member" />
      </div>
      <KickoutMemberModal
        isOpen={isOpen}
        onClose={() => setModalOpen(false)}
        userName={userName}
        kickoutMemberPath={kickoutMemberPath}
      />
    </>
  );
}

export default KickoutMemberButton;
